import { permissionSchema } from '@/backend/features/authentication/shared';
import { useTranslation } from '@/ui/hooks';
import { WidgetFormConfig } from '@juvare/common-form-ui/WidgetForm';
import React from 'react';

export function useUserFormConfig(action: 'add' | 'edit'): WidgetFormConfig {
    const { t } = useTranslation();
    return React.useMemo(
        () => ({
            type: 'form',
            children: [
                {
                    type: 'form.email',
                    key: 'email',
                    label: t('email'),
                    validate: { required: true },
                    disabled: action === 'edit',
                },
                {
                    type: 'form.text',
                    key: 'firstName',
                    label: t('firstName'),
                },
                {
                    type: 'form.text',
                    key: 'lastName',
                    label: t('lastName'),
                },
                {
                    type: 'form.checkboxList',
                    key: 'permissions',
                    label: t('permissions'),
                    values: permissionSchema.options.map((permission) => ({
                        value: permission,
                        label: t(`permissionEnum.${permission}`),
                    })),
                },
            ],
        }),
        [t, action],
    );
}
